import { tradingAssetChartDrawLayer } from "@tradingApp/components/Trading/AssetChart/helpers/drawLayer";
import type { Options } from "@tradingApp/components/Trading/AssetChart/types";
import { cloneCanvas } from "@tradingApp/helpers/canvas/cloneCanvas";
import { mergeCanvasLayers } from "@tradingApp/helpers/canvas/mergeCanvasLayers";

export function tradingAssetChartDrawLine(options: Options): void {
  const { xScale, yScale, data, dates, destinationCanvas } = options;

  const isDestinationCanvasValid =
    destinationCanvas instanceof HTMLCanvasElement;

  if (
    !isDestinationCanvasValid ||
    typeof xScale !== "function" ||
    typeof yScale !== "function" ||
    !Array.isArray(data) ||
    !Array.isArray(dates)
  ) {
    return;
  }

  const [layerContext, layerCanvas] = cloneCanvas(destinationCanvas, true);

  tradingAssetChartDrawLayer(options, layerContext);
  mergeCanvasLayers(layerCanvas, destinationCanvas);
}
